import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-link-task',
  templateUrl: './icon-link-task.component.html',
  styleUrls: ['./icon-link-task.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconLinkTaskComponent {}
